import axios from 'axios';
import jwt from 'jsonwebtoken';
import moment from 'moment';

const apiUrl = process.env.API_URL || 'http://127.0.0.1:8080';

function baseHeaders(contentType) {
    return {
        'Content-Type': contentType || 'application/json',
    };
}

function loggedHeaders(contentType) {
    return Object.assign({}, baseHeaders(contentType), {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
    });
}

export default {

    createSession(data) {
        return axios.post(`${apiUrl}/a/session`, data, { headers: loggedHeaders() });
    },

    getNotificationMethods() {
        return axios.get(`${apiUrl}/a/notification-methods`, { headers: loggedHeaders() });
    },

    getSession(session) {
        return axios.get(`${apiUrl}/a/session/${session}`, { headers: baseHeaders() });
    },

    getSessions() {
        return axios.get(`${apiUrl}/a/session`, { headers: loggedHeaders() });
    },

    isLogged() {
        const token = localStorage.getItem('token');
        if (!token) return false;
        const decoded = jwt.decode(token);
        if (moment().unix() >= decoded.exp) return false;
        return true;
    },

    isAdmin() {
        const token = localStorage.getItem('token');
        if (!token) return false;
        const decoded = jwt.decode(token);
        return decoded.type === 1;
    },

    getUser() {
        const token = localStorage.getItem('token');
        if (!token) return false;
        const decoded = jwt.decode(token);
        return decoded.username;
    },

    login(data) {
        return axios.post(`${apiUrl}/a/login`, data, { headers: baseHeaders() });
    },

    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
    },

    deleteSession(id, notify) {
        return axios.delete(`${apiUrl}/a/session/${id}`, {
            headers: loggedHeaders(),
            params: { notify },
        });
    },

    changePwd(data) {
        return axios.put(`${apiUrl}/a/password`, data, { headers: loggedHeaders() });
    },

    getProfessionals() {
        return axios.get(`${apiUrl}/a/professional`, { headers: loggedHeaders() });
    },

    createProfessional(data) {
        return axios.post(`${apiUrl}/a/professional`, data, { headers: loggedHeaders() });
    },

    deleteProfessional(username) {
        return axios.delete(`${apiUrl}/a/professional/${username}`, { headers: loggedHeaders() });
    },

    passwordRecovery(data) {
        return axios.post(`${apiUrl}/a/password/recovery`, data, { headers: baseHeaders() });
    },

    getConfig() {
        return axios.get(`${apiUrl}/a/config`, { headers: loggedHeaders() });
    },

    getConfigPayment() {
        return axios.get(`${apiUrl}/a/config/payment`, { headers: baseHeaders() });
    },

    sendEmail(data) {
        return axios.post(`${apiUrl}/a/notification`, data, { headers: loggedHeaders('multipart/form-data') });
    },

    increaseCallCount() {
        return axios.post(`${apiUrl}/a/stats/calls`, undefined, { headers: loggedHeaders() });
    },

    paypalCreateOrder(sessionId) {
        return axios.post(`${apiUrl}/a/session/${sessionId}/payment`, undefined, { headers: baseHeaders() });
    },

    paypalUpdateOrder(sessionId) {
        return axios.put(`${apiUrl}/a/session/${sessionId}/payment`, undefined, { headers: baseHeaders() });
    },

    getYears() {
        return axios.get(`${apiUrl}/a/stats/years`, { headers: loggedHeaders() });
    },

    getStats(year) {
        return axios.get(`${apiUrl}/a/stats/${year}`, { headers: loggedHeaders() });
    },

}



// WEBPACK FOOTER //
// ./src/services/HealthCareService.js